export class MMKV {
  constructor(config) {
    this._prefix = (config && config.id) ? `mmkv_${config.id}_` : 'mmkv_';
  }

  getString(key) {
    return localStorage.getItem(this._prefix + key) ?? undefined;
  }

  set(key, value) {
    localStorage.setItem(this._prefix + key, String(value));
  }

  delete(key) {
    localStorage.removeItem(this._prefix + key);
  }

  contains(key) {
    return localStorage.getItem(this._prefix + key) !== null;
  }

  clearAll() {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(this._prefix)) keysToRemove.push(k);
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
  }

  getNumber(key) {
    const v = localStorage.getItem(this._prefix + key);
    return v !== null ? Number(v) : undefined;
  }

  getBoolean(key) {
    const v = localStorage.getItem(this._prefix + key);
    return v !== null ? v === 'true' : undefined;
  }

  getAllKeys() {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(this._prefix)) keys.push(k.slice(this._prefix.length));
    }
    return keys;
  }
}
